/**
 * The window event the builder sends the playground guide when a publish finishes (ReviewPublish):
 * the guide's last step; and the trial guide's cut list view. A plain event, so the publish code doesn't depend on the guide.
 */
export const TOUR_EVENT = 'tc:tour';

const announce = (type, extra = {}) => {
  try {
    window.dispatchEvent(new CustomEvent(TOUR_EVENT, { detail: { ...extra, type } }));
  } catch {
    // no window
  }
};

/** `testOrder`: the uuid a trial's first publish made, for the build guide's hand-off tip (or null). */
export const announcePublished = ({ testOrder = null } = {}) => announce('published', { testOrder });

/** A cut list was viewed (trackCutListViewed, or an order item's cut sheet printed or downloaded): the trial guide's cut list step. */
export const announceCutListViewed = () => announce('cut_list_viewed');

/** An order's quote was opened (Payments › Quotes & invoices): the trial guide's quote step. */
export const announceQuoteViewed = () => announce('quote_viewed');

/** An order was moved to a station (the order page's Production status strip): the trial guide's station step. */
export const announceStationMoved = () => announce('station_moved');
